export const specialFlavour = [
  {
    id: "1",
    name: "Real Crown Crust",
    priceM: "1200",
    priceL: "1650",
    priceXL: "2050",
  },
  {
    id: "2",
    name: "Real Lasagne",
    priceM: "1200",
    priceL: "1650",
    priceXL: "2050",
  },
  {
    id: "3",
    name: "Real Behari Kabab Crust",
    priceM: "1300",
    priceL: "1800",
    priceXL: "2150",
  },
  {
    id: "4",
    name: "Peri Peri Behari Special",
    priceM: "1300",
    priceL: "1800",
    priceXL: "2150",
  },
  {
    id: "5",
    name: "Crunchy Pizza",
    priceM: "1300",
    priceL: "1800",
    priceXL: "2150",
  },
  {
    id: "6",
    name: "Real Kabab Crust",
    priceM: "1100",
    priceL: "1650",
    priceXL: "2050",
  },
  {
    id: "7",
    name: "Real Behari Kabab",
    priceM: "1100",
    priceL: "1650",
    priceXL: "2050",
  },
  {
    id: "8",
    name: "Super Supreme",
    priceM: "1100",
    priceL: "1600",
    priceXL: "2000",
  },
  {
    id: "9",
    name: "Malai Boti Special",
    priceM: "1100",
    priceL: "1600",
    priceXL: "2000",
  },
];
